import axios, {AxiosResponse} from 'axios'
import {IBaseResponse} from '../../auth'
import {IClassQuiz} from '../../../models/IClassQuiz'

const API_URL = process.env.REACT_APP_BASE_API_URL
const STUDENT_URL = `${API_URL}/students`

export type StudentScheduledQuizGroup = {
  classId: number
  className: string
  courseName?: string
  quizzes: IClassQuiz[]
}

const getScheduledQuizzes = (): Promise<IBaseResponse<StudentScheduledQuizGroup[]>> => {
  return axios
    .get(`${STUDENT_URL}/me/scheduled-quizzes`)
    .then((r: AxiosResponse<IBaseResponse<StudentScheduledQuizGroup[]>>) => r.data)
}

export {getScheduledQuizzes}
